/**
 * Pure mapping helpers between the canonical `ContactNote[]` persistence
 * shape and the `Activity[]` display shape used by the activity timeline.
 *
 * Extracted verbatim from `ContactEditModal.tsx` (behavior-preserving — #3237).
 */

import type { Activity, ContactNote } from './types';

/** Convert ContactNote[] (canonical) to Activity[] for display */
export function notesToActivities(notes: ContactNote[]): Activity[] {
  return notes.map(n => ({
    id: n.id,
    date: n.createdAt,
    note: n.content,
    authorId: n.authorId,
    authorName: n.authorName,
    type: n.type,
  }));
}

/** Convert Activity[] back to ContactNote[] for persistence */
export function activitiesToNotes(activities: Activity[]): ContactNote[] {
  return activities.map(a => ({
    id: a.id,
    content: a.note,
    createdAt: a.date,
    authorId: a.authorId || '',
    authorName: a.authorName || 'Unknown',
    type: a.type,
  }));
}
